/**
 * @description  将url的query参数解析成对象
 * @param       {[string]}                 url [不传则取当前页面url]
 * @return      {[object]}                     [参数对象]
 */
const getParams = (url?: string): Record<string, string> => {
  if (!url) {
    url = window.location.href;
  }
  const params: Record<string, string> = {};
  let name, value;
  url = url.split('#').length > 1 ? url.split('#')[1] : url.split('#')[0];
  const idx = url.indexOf('?');
  const search = idx > -1 ? url.slice(idx + 1) : '';
  const arrTmp = search.split('&');
  for (let i = 0; i < arrTmp.length; i++) {
    const paramCount = arrTmp[i].indexOf('=');
    if (paramCount > 0) {
      name = arrTmp[i].slice(0, paramCount);
      value = arrTmp[i].slice(paramCount + 1);
      try {
        if (value.indexOf('+') > -1) {
          value = value.replace(/\+/g, ' ');
        }
        params[name] = decodeURIComponent(value);
      } catch (exp) {
        console.error(exp);
      }
    }
  }
  return params;
};

export default getParams;
